import React, { useEffect, useRef, useState } from "react";
import { IoMdCall } from "react-icons/io";
import {
  BiArrowBack,
  BiCurrentLocation,
  BiSolidInfoCircle,
} from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { render } from "react-dom";
import axios from "axios";
import Form from "react-bootstrap/Form";
import {
  setLocalityScooring,
  setLocationDetails,
  setPostPropertyStepsStatus,
  setaminitiesScooring,
  setbasicdetailScooring,
  setmainpropertyScooring,
  setphotoScooring,
  setpricingScooring,
  setpropertyScooring,
} from "../../../../redux/property/PropertySlice";
import { Baseurl } from "../../../../config/BaseUrl";

const EditOfficeLocationDetails = () => {
  const {
    singleProperty,
    LocationDetails,
    basicdetailScooring,
    mainpropertyScooring,
    photoScooring,
    pricingScooring,
    aminitiesScooring,
  } = useSelector((state) => state.Property);
  const dispatch = useDispatch();
  const mainref = useRef();
  const loclityref = useRef();

  const [propertySearch, setPropertySearch] = useState([]);
  const [distictcity, setDistictcity] = useState([]);
  const [city, setCity] = useState("");
  const [showdistictcity, setShowDistictcity] = useState([]);
  const [showCitypop, setShowCitypop] = useState(false);

  const [apptandlcltbyCity, setApptandlcltbyCity] = useState([]);

  const [localitybyCity, setLocalitybyCity] = useState([]);
  const [showLocalitybyCity, setShowLocalitybyCity] = useState([]);
  const [showLocality, setShowLocality] = useState(false);

  const [apartmentbyCity, setApartmentbyCity] = useState([]);
  const [showApartmentbyCity, setShowApartmentbyCity] = useState([]);
  const [showApartment, setShowApartment] = useState(false);

  const [apartment, setApartment] = useState("");
  const [locality, setLocality] = useState("");
  const [subLocality, setSubLocality] = useState("");

  const [locatedValue, setLocatedValue] = useState(
    singleProperty.locatedInside
  );
  const [zoneType, setZoneType] = useState(singleProperty.zoneType);

  const [locationDetailsError, setLocationDetailsError] = useState("");

  const [cityResults, setCityShowResults] = useState(false);
  const [localityResults, setLocalityShowResults] = useState(false);
  const [apartmentResults, setApartmentResults] = useState(false);

  const locatedInside = [
    { id: 1, name: "IT Park" },
    { id: 2, name: "Business Park" },
    { id: 3, name: "Others" },
  ];
  const zonetypeArray = [
    { id: 1, name: "Industrial" },
    { id: 2, name: "Commercial" },
    { id: 3, name: "Residential" },
    { id: 4, name: "Transport and Communication" },
    { id: 5, name: "Public Utilities" },
    { id: 6, name: "Public and Semi Public Use" },
    { id: 7, name: "Open Spaces" },
    { id: 8, name: "Agriculture Zone" },
    { id: 9, name: "Special Economic Zone" },
    { id: 10, name: "Natural Conservation Zone" },
    { id: 11, name: "Government Use " },
    { id: 12, name: "Other" },
  ];

  //--------------------CITY Start--------------------------------//

  useEffect(() => {
    const fetchData = async () => {
      const url = `${Baseurl}/api/v1/property/allcities`;
      const fetchProperty = await axios.get(url);
      try {
        if (fetchProperty.data.success === true) {
          const cityresult = fetchProperty.data.cities;
          setDistictcity(cityresult);
        }
      } catch (error) {}
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (city !== "") {
      const cityall = distictcity.filter((item) =>
        item.toLowerCase().match(city.toLowerCase())
      );
      setShowDistictcity(cityall);
    }
  }, [city]);

  const selectCityClick = (e, city) => {
    setCity(city);
    const fetchData1 = async () => {
      const url = `${Baseurl}/api/v1/property/apartmentnew/${city}`;
      const fetchProperty = await axios.get(url);
      try {
        if (fetchProperty.data.success === true) {
          const apartmentsresult = fetchProperty.data.apartments;
          setApptandlcltbyCity(apartmentsresult);
        }
      } catch (error) {}
    };
    fetchData1();
    const fetchData = async () => {
      const url = `${Baseurl}/api/v1/property/alllocalities/${city}`;
      const fetchProperty = await axios.get(url);
      try {
        if (fetchProperty.data.success === true) {
          const localitiesresult = fetchProperty.data.localities;
          setLocalitybyCity(localitiesresult);
        }
      } catch (error) {}
    };
    fetchData();
  };

  const cityBlur = () => {
    let mycity =
      city.charAt(0).toUpperCase() + city.slice(1).trim().toLowerCase();
    setCity(mycity);
    const fetchData1 = async () => {
      const url = `${Baseurl}/api/v1/property/apartmentnew/${mycity}`;

      const fetchProperty = await axios.get(url);

      try {
        if (fetchProperty.data.success === true) {
          const apartmentsresult = fetchProperty.data.apartments;
          if (apartmentsresult.length > 0) {
            setApptandlcltbyCity(apartmentsresult);
            setShowApartmentbyCity(apartmentsresult);
          }
        }
      } catch (error) {}
    };
    fetchData1();
    const fetchData = async () => {
      const url = `${Baseurl}/api/v1/property/alllocalities/${mycity}`;
      const fetchProperty = await axios.get(url);
      try {
        if (fetchProperty.data.success === true) {
          const localitiesresult = fetchProperty.data.localities;
          setLocalitybyCity(localitiesresult);
        }
      } catch (error) {}
    };
    fetchData();
  };

  //--------------------CITY End--------------------------------//

  //--------------------LOCALITY Start--------------------------------//
  useEffect(() => {
    if (locality !== "") {
      const localotyall = localitybyCity.filter((item) =>
        item.toLowerCase().match(locality.toLowerCase())
      );
      setShowLocalitybyCity(localotyall);
    }
  }, [locality]);

  const localityClick = (e, locality) => {
    setLocality(locality);
  };

  const locateInsideChange = (e) => {
    const { value } = e.target;
    const index = e.nativeEvent.target.selectedIndex;
    const text = e.nativeEvent.target[index].text;
    setLocatedValue(text);
  };

  const zoneTypeChange = (e) => {
    const { value } = e.target;
    const index = e.nativeEvent.target.selectedIndex;
    const text = e.nativeEvent.target[index].text;
    setZoneType(text);
  };

  useEffect(() => {
    if (singleProperty !== "") {
      setCity(singleProperty.city);
      setApartment(singleProperty.apartment);
      setLocality(singleProperty.locality);
      setSubLocality(singleProperty.SubLocality);
      setLocatedValue(singleProperty.locatedInside);
      setZoneType(singleProperty.zoneType);
    }
  }, [singleProperty]);

  useEffect(() => {
    let totalcount = 0;
    let cityperchnage = 0;
    if (city !== "") {
      cityperchnage = 5;
    } else {
      cityperchnage = 0;
    }
    let apartmentcount = 0;
    if (apartment !== "") {
      apartmentcount = 5;
    } else {
      apartmentcount = 0;
    }
    let localityCount = 0;
    if (locality !== "") {
      localityCount = 5;
    } else {
      localityCount = 0;
    }

    totalcount = cityperchnage + apartmentcount + localityCount;
    dispatch(setLocalityScooring(totalcount));
    dispatch(setbasicdetailScooring(basicdetailScooring));
    dispatch(setphotoScooring(photoScooring));
    dispatch(setpricingScooring(pricingScooring));
    dispatch(setaminitiesScooring(aminitiesScooring));
    dispatch(setmainpropertyScooring(mainpropertyScooring));

    dispatch(setpropertyScooring());
  }, [city, apartment, locality]);

  const locationDetailsClick = async (e) => {
    e.preventDefault();
    if (city !== " " && locality !== "") {
      const locationDetails = {
        city: city,
        apartment: apartment,
        locality: locality,
        subLocality: subLocality,
        // housenumber: housenumber,
        locatedInside: locatedValue,
        zoneType: zoneType,
      };

      dispatch(setLocationDetails(locationDetails));
      dispatch(setPostPropertyStepsStatus(2));
    } else {
      setLocationDetailsError("Please enter locality Details");
    }
  };

  useEffect(() => {
    const clickoutside = (e) => {
      if (
        cityResults &&
        mainref.current &&
        !mainref.current.contains(e.target)
      ) {
        setCityShowResults(false);
      }
    };
    document.addEventListener("click", clickoutside);
    return () => {
      document.addEventListener("click", clickoutside);
    };
  }, [cityResults]);

  useEffect(() => {
    const clickoutside = (e) => {
      if (
        apartmentResults &&
        loclityref.current &&
        !loclityref.current.contains(e.target)
      ) {
        setApartmentResults(false);
      }
    };
    document.addEventListener("click", clickoutside);
    return () => {
      document.addEventListener("click", clickoutside);
    };
  }, [apartmentResults]);

  useEffect(() => {
    const clickoutside = (e) => {
      if (
        localityResults &&
        loclityref.current &&
        !loclityref.current.contains(e.target)
      ) {
        setLocalityShowResults(false);
      }
    };
    document.addEventListener("click", clickoutside);
    return () => {
      document.addEventListener("click", clickoutside);
    };
  }, [localityResults]);
  return (
    <>
      <div
        className="ppfDesktop_mainWrapper__k7Xv0 null"
        style={{ marginTop: "0px" }}
      >
        <div className="false ppfDesktop_formSection__ZzvPA">
          <div className="page_ppf_step1__1icHe  pageComponent">
            <div className="PrimaryDetailsHeader-desktopHeader">
              <div className="desktopHeader_iconInlineHead__W8_RL">
                <div className="caption_subdued_medium">
                  <span
                    className="desktopHeader_backArrow__1lVxQ iconS_PPFDesk_24 icon_backGrey"
                    style={{ fontSize: "20px", marginRight: "5px" }}
                  >
                    <BiArrowBack />
                  </span>
                  <div style={{ fontSize: "14px" }}>Back</div>
                </div>
                <div className="desktopHeader_text__3iyVt">
                  <div className="undefined title_l_semiBold">
                    Where is your property located?
                  </div>
                  <div className="caption_subdued_large">
                    An accurate location helps you connect with the right buyers
                  </div>
                </div>
              </div>
            </div>
            <div id="Location-widget">
              <div className="widgetbox_white_box__1v7xz undefined undefined undefined">
                <div className="location_fieldsWrapper__3sary">
                  <div className="city_citySuggestor__21uXN">
                    <div className="suggestor_suggestor__pe1Hh">
                      <div className="textInput_inputContainer__2PwgZ  textInput_multiple_input__1JPry undefined">
                        <div className="textInput_iconsWrapper__2cgSX">
                          <div className="city_detectLocationWrapper__1Le9J">
                            <span className="detectLocation_rightText__3ew7q pageComponent">
                              <span className="hyperlinks_medium">
                                <i>
                                  <BiCurrentLocation />
                                </i>
                                Pick my location
                              </span>
                            </span>
                          </div>
                          <div className="screeningActions_iconWrapper__dB1NM"></div>
                        </div>
                        <div className="">
                          <input
                            type="text"
                            placeholder="City"
                            id="city"
                            autoComplete="off"
                            ref={mainref}
                            style={{ textTransform: "capitalize" }}
                            value={city}
                            onChange={(e) => {
                              setCity(e.target.value);
                              setShowCitypop(true);
                              setCityShowResults(true);
                            }}
                            onBlur={(e) => cityBlur(e)}
                          />
                          <div>
                            {cityResults &&
                            city.length > 0 &&
                            showCitypop &&
                            showdistictcity.length > 0 ? (
                              <>
                                <div
                                  className=""
                                  style={{
                                    textAlign: "start",
                                    border: "1px solid #eee",
                                    backgroundColor: "#fff",
                                    padding: "5px",
                                    zIndex: "99",
                                    position: "absolute",
                                    left: "0",
                                    right: "0",
                                    height: "15vh",
                                    overflowY: "scroll",
                                  }}
                                >
                                  <ul>
                                    {showdistictcity.map((city, index) => (
                                      <li
                                        style={{ paddingTop: "8px" }}
                                        key={index}
                                        onClick={(e) => {
                                          selectCityClick(e, city);
                                          setShowCitypop(false);
                                        }}
                                      >
                                        {city}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>

                          <div className="textInput_placeholder__1KRsF caption_strong_large textInput_placeholderWithoutError__3FjSB">
                            <span className="undefined"></span>
                          </div>
                        </div>
                      </div>
                      <div
                        className="textInput_inputContainer__2PwgZ  textInput_multiple_input__1JPry undefined"
                        style={{ position: "relative" }}
                      >
                        <div className="">
                          <input
                            type="text"
                            id="project"
                            placeholder="Locality"
                            autoComplete="off"
                            style={{ textTransform: "capitalize" }}
                            ref={loclityref}
                            value={locality}
                            onChange={(e) => {
                              setLocality(e.target.value);
                              setShowLocality(true);
                              setLocalityShowResults(true);
                            }}
                          />
                          {localityResults &&
                          city.length > 0 &&
                          showLocality &&
                          showLocalitybyCity.length > 0 ? (
                            <>
                              <div
                                className=""
                                style={{
                                  textAlign: "start",
                                  border: "1px solid #eee",
                                  backgroundColor: "#fff",
                                  padding: "5px",
                                  zIndex: "99",
                                  position: "absolute",
                                  left: "0",
                                  right: "0",
                                  height: "20vh",
                                  overflowY: "scroll",
                                }}
                              >
                                <ul>
                                  {showLocalitybyCity.map(
                                    (locality, index1) => (
                                      <li
                                        style={{ paddingTop: "8px" }}
                                        key={index1}
                                        onClick={(e) => {
                                          localityClick(e, locality);
                                          setShowLocality(false);
                                        }}
                                      >
                                        {locality}
                                      </li>
                                    )
                                  )}
                                </ul>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}

                          <div>
                            {/* <span className='textInput_errMsgTxt__OXfZT'>Please enter Locality</span> */}
                          </div>
                          <div className="textInput_placeholder__1KRsF caption_strong_large textInput_placeholderWithoutError__3FjSB">
                            <span className="undefined"></span>
                          </div>
                        </div>
                      </div>
                      <div className="textInput_inputContainer__2PwgZ  textInput_multiple_input__1JPry undefined">
                        <div className="">
                          <div className="textInput_iconsWrapper__2cgSX">
                            {/* <i className='iconS_PPFDesk_24 icon_redInfo'><BiSolidInfoCircle/></i> */}
                            <div className="screeningActions_iconWrapper__dB1NM"></div>
                          </div>
                          <input
                            type="text"
                            id="project"
                            style={{ textTransform: "capitalize" }}
                            placeholder="Sub-locality(Optional)"
                            value={subLocality}
                            onChange={(e) => setSubLocality(e.target.value)}
                          />
                          <div></div>
                          <div>
                            {/* <span className='textInput_errMsgTxt__OXfZT'>Please enter Locality</span> */}
                          </div>
                          <div className="textInput_placeholder__1KRsF caption_strong_large textInput_placeholderWithoutError__3FjSB">
                            <span className="undefined"></span>
                          </div>
                        </div>
                      </div>
                      <div className="textInput_inputContainer__2PwgZ  textInput_multiple_input__1JPry undefined">
                        <div className="">
                          <input
                            type="text"
                            placeholder=" Project name (Optional)"
                            id="project"
                            autoComplete="off"
                            style={{ textTransform: "capitalize" }}
                            value={apartment}
                            onChange={(e) => {
                              setApartment(e.target.value);
                            }}
                          />

                          <div className="textInput_placeholder__1KRsF caption_strong_large textInput_placeholderWithoutError__3FjSB">
                            <span className="undefined"></span>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="listsearch-input-item">
                            <Form.Select
                              data-placeholder="All Types"
                              className="nice-select myclassoption chosen-select no-search-select large-select"
                              onChange={(e) => locateInsideChange(e)}
                              value={locatedInside.id}
                              name={locatedInside.name}
                            >
                              <option value="0" selected disabled hidden>
                                {"Located Inside (optional)"}
                              </option>
                              {locatedInside.map((locate, index) => (
                                <option
                                  key={index}
                                  value={locate.id}
                                  name={locate.name}
                                  required
                                >
                                  {locate.name}
                                </option>
                              ))}
                            </Form.Select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="listsearch-input-item">
                            <Form.Select
                              data-placeholder="All Types"
                              className="nice-select myclassoption chosen-select no-search-select large-select"
                              onChange={(e) => zoneTypeChange(e)}
                              value={zonetypeArray.id}
                              name={zonetypeArray.name}
                            >
                              <option value="0" selected disabled hidden>
                                {"Zone Type (optional)"}
                              </option>
                              {zonetypeArray.map((zone, index) => (
                                <option
                                  key={index}
                                  value={zone.id}
                                  name={zone.name}
                                  required
                                >
                                  {zone.name}
                                </option>
                              ))}
                            </Form.Select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p style={{ color: "red" }}>{locationDetailsError}</p>
              <div id="PrimaryDetailsButtonsWrapper-widget">
                <div className="dummyFormWidget_flexContainer__2vVMv">
                  <div
                    id="PrimaryDetailsButton-button"
                    className="pageComponent"
                  >
                    <div>
                      <div className="buttonInput_continue_btn__1gb5M ">
                        <button
                          type="button"
                          className="pageComponent buttons_primaryRegular__rU-bm buttons_semi__1it_o undefined"
                          onClick={(e) => locationDetailsClick(e)}
                        >
                          <span>
                            <span>Continue</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditOfficeLocationDetails;
